module.exports = __webpack_public_path__ + "img/bg.85250f5c.jpg";